<template>
  <div>
    <div class="htmlBox">
      <h4 class="title">注册账号</h4>
      <article class="tips">请填写一下注册的基本信息</article>
      <div class="userinfo">
        <ul>
          <li>
            <p>手机号</p>
            <input type="tel" maxlength="11" placeholder="请输入手机号" v-model="phone" />
          </li>
          <li>
            <p>图片验证码</p>
            <input class="w200" type="num" placeholder="请输入图片验证码 " v-model="imgcode" />
            <img :src="codeImage" @click="getCaptcha()" alt="" />
          </li>
          <li>
            <p>短信验证码</p>
            <input class="w200" type="number" name="" id="" value="" placeholder="请输入验证码" v-model="code" />
            <em @click="getcode()" v-if="sign == false">发送验证码</em>
            <em v-else style="background:#BBBBBB;color:#fff ">{{ codehtml }}S</em>
          </li>
          <li>
            <p>邀请码</p>
            <input class="w200" type="number" disabled placeholder="请输入邀请码" v-model="invitaCode" />
          </li>
          <li>
            <p>密码</p>
            <input class="w200" type="password" placeholder="请输入密码" v-model="pwd" />
          </li>
          <li>
            <p>确认密码</p>
            <input class="w200" type="password" placeholder="请输入密码" v-model="pwdtwo" />
          </li>
        </ul>
      </div>

      <div class="xieyi" v-if="hidshow">
        <Iconfont name="iconselected" class="icon" size="0.6rem" color="#FD3E3E" v-if="isProtocol"
          @click="protocolFg" />
        <Iconfont @click="protocolFg" name="iconweixuanzhong" class="icon" size="0.6rem" color="#999" v-else />
        <span @click="protocolFg">已阅读同意</span>
        <b>
          <span @click="goPath('/userAgreement')">《用户服务协议》</span><span
            @click="goPath('/serviceAgreement')">《隐私保护政策》</span></b>
      </div>
      <button v-if="hidshow" :disabled="btnState == false" :class="{ btnBg: btnState }" @click="sure()">
        注册
      </button>
    </div>
  </div>
</template>

<script>
  import Iconfont from '@/components/iconfont.vue'
  import { sendRequest } from '@/assets/public'
  import { Toast } from 'vant'
  export default {
    data() {
      return {
        phone: '',
        imgcode: '',
        code: '',
        invitaCode: '',
        pwd: '',
        pwdtwo: '',
        codehtml: 60,
        sign: false,
        codeImage: '',
        codeKey: '',
        setTime: true,
        docmHeight: document.documentElement.clientHeight, //默认屏幕高度
        showHeight: document.documentElement.clientHeight, //实时屏幕高度
        hidshow: true, //显示或者隐藏footer
        isProtocol: true,
      }
    },
    created() {
      window.onresize = () => {
        return (() => {
          this.showHeight = document.body.clientHeight
        })()
      }
      this.invitaCode = localStorage.getItem('store_id'),
        this.getCaptcha()
    },
    methods: {
      // 协议
      protocolFg() {
        this.isProtocol = !this.isProtocol
      },
      // 获取img
      async getCaptcha() {
        if (!this.setTime) {
          return
        }
        this.setTime = false
        let res = await sendRequest('user/getCaptcha', {})
        if (res.status == 200) {
          this.codeImage = res.content.img
          this.codeKey = res.content.key
          setTimeout(() => {
            this.setTime = true
          }, 500)
        }
      },
      // 发送验证码
      async getcode() {
        if (!/^1[3456789]\d{9}$/.test(this.phone)) {
          Toast('手机号码有误')
          return false
        } else {
          if (this.imgcode == '') {
            Toast('请输入图形验证码')
            return
          }
          let params = {
            phone_mob: this.phone,
            captcha_code: this.imgcode,
            key: this.codeKey,
          }
          let res = await sendRequest('user/sendNoCodeSms', params)
          if (res.status == 200) {
            this.codehtml = 60
            this.sign = true
            let tim = setInterval(() => {
              this.codehtml = this.codehtml - 1
              if (this.codehtml <= 0) {
                clearInterval(tim)
                this.sign = false
                return false
              }
            }, 1000)
            this.time = tim
          } else {
            Toast(res.msg)
          }
        }
      },
      async sure() {
        let tips = false // 提示信息
        if (this.pwd == '') {
          tips = '请输入密码'
        }
        if (this.pwdtwo == '') {
          tips = '请再次输入密码'
        }
        if (this.pwd != this.pwdtwo) {
          tips = '两次输入密码不一致'
        }
        if (this.code == '') {
          tips = '请输入短信验证码'
        }
        if (this.imgcode == '') {
          tips = '请输入图形验证码'
        }
        if (!/^1[3456789]\d{9}$/.test(this.phone)) {
          tips = '手机号码有误'
        }

        if (tips) {
          Toast(tips)
          return
        }
        let { content, status, msg } = await sendRequest('user/registerH5', {
          phone_mob: this.phone,
          sms_code: this.code,
          invitation_code: this.invitaCode,
          pwd: this.pwd,
          pwd_confirm: this.pwdtwo,
        })
        if (status == 200) {
          Toast('注册成功')
          localStorage.setItem('token', content.token)
          localStorage.setItem('infor', JSON.stringify(content))
          setTimeout(() => {
            this.$router.replace('/personalCenter')
          }, 300)
        } else {
          Toast(msg)
        }
      },
    },
    components: { Iconfont },

    computed: {
      btnState() {
        //当用户名和密码框都不为空时btnState==true,利用这个计算属性来动态控制按钮的禁用和颜色
        return (
          this.phone !== '' &&
          this.code !== '' &&
          this.pwd !== '' &&
          this.pwdtwo !== ''
        )
      },
    },
    watch: {
      showHeight() {
        if (this.docmHeight > this.showHeight) {
          this.hidshow = false
        } else {
          this.hidshow = true
        }
      },
    },
  }
</script>
<style scoped>
  /*button禁用时的背景颜色*/
  button {
    width: 13.6rem;
    height: 2rem;
    background: rgba(221, 221, 221, 1);
    border-radius: 0.2rem;
    position: absolute;
    bottom: 1.6rem;
    left: 0.7rem;
    line-height: 2rem;
    font-size: 0.6rem;
    color: #fff;
    border: none;
  }

  /*button可用时的背景颜色*/
  .btnBg {
    width: 13.6rem;
    height: 2rem;
    border-radius: 0.2rem;
    position: absolute;
    bottom: 1.6rem;
    left: 0.7rem;
    line-height: 2rem;
    font-size: 0.6rem;
    color: #fff;
    background: #fd3e3e;
    border: none;
  }

  .htmlBox {
    height: 100%;
    display: block;
    background: #fff;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
  }

  .title {
    font-size: 0.96rem;
    color: #333333;
    font-weight: normal;
    margin: 1.4rem 0 0.6rem;
    text-align: center;
  }

  .tips {
    color: #999999;
    font-size: 0.56rem;
    margin: 0;
    text-align: center;
  }

  .userinfo {
    width: 100vw;
    padding-top: 1.2rem;
  }

  .userinfo ul {
    padding: 0 0.8rem;
  }

  .userinfo ul li {
    height: 1.6rem;
    line-height: 1.6rem;
    padding-top: 0.4rem;
    border-bottom: 1px solid #eee;
    overflow: hidden;
  }

  .userinfo ul li p {
    float: left;
    font-size: 0.56rem;
    color: #333333;
    width: 3.5rem;
  }

  .userinfo ul li input {
    width: 7rem;
    float: left;
    border: none;
    font-size: 0.56rem;
    padding-left: 0.4rem;
    line-height: 1.5rem;
  }

  .userinfo ul li input.w200 {
    width: 5rem !important;
  }

  .userinfo ul li em {
    width: 3.6rem;
    height: 1.4rem;
    background: #fd3e3e;
    border-radius: 0.2rem;
    color: #fff;
    line-height: 1.4rem;
    float: right;
    font-size: 0.56rem;
    font-style: normal;
    text-align: center;
  }

  .userinfo ul li img {
    display: block;
    width: 3.6rem;
    height: 1.4rem;
    float: right;
  }

  .sure_btn {
    width: 13.6rem;
    height: 2rem;
    background: rgba(221, 221, 221, 1);
    border-radius: 0.2rem;
    position: absolute;
    bottom: 1.6rem;
    left: 0.7rem;
    line-height: 2rem;
    font-size: 0.6rem;
    color: #fff;
  }

  .active {
    background: #fd3e3e !important;
  }

  .xieyi {
    position: fixed;
    bottom: 4rem;
    left: 0;
    width: 100%;
    font-size: 0.46rem;
    text-align: center;
    color: rgba(51, 51, 51, 1);
  }

  .xieyi .iconfont {
    margin-right: 0.3rem;
  }

  .xieyi b {
    color: #fd3e3e;
  }
</style>